// extracted by mini-css-extract-plugin
export var cancelButton = "_o3-5";
export var content = "_o3-3";
export var createButton = "_o3-6";
export var drawerContainer = "_o3-0";
export var footer = "_o3-2";
export var header = "_o3-1";
export var orderFormColumn = "_o3-4";